import { css } from '@emotion/react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Button from 'components/field/Button';
import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import useLocalStorage from 'hooks/useLocalStorage';
import useSwitchSupportClient from 'hooks/useSwitchSupportClient';

import { faArrowsRotate, faRepeat, faRightFromBracket, faXmarkCircle } from '@fortawesome/pro-solid-svg-icons';

import * as S from './SideBar.styled';

const SwitchCustomer = ({ closePopper }) => {
	const [lastSwitchUsers] = useLocalStorage('lastSwitchUsers', []);
	const [supportAccessUntil] = useLocalStorage('supportAccessUntil', null);
	const currentUserId = useSelector((state) => state.user.ID);
	const switchSupportClient = useSwitchSupportClient();
	const { t } = useTranslation();

	return (
		<S.SwitchPopperContainer>
			<S.PaddingDiv>
				<Typography variant="p1">lastClientUserLogins</Typography>
				{lastSwitchUsers.map((user) => (
					<S.ProfileOuterRow key={user.clientUserId}>
						<S.ProfileInnerRow>
							<div>
								<Typography>{user.fullName}</Typography>
								<Typography>{user.email}</Typography>
							</div>
							{user.clientUserId !== currentUserId ? (
								<Button
									icon={user.status === 'Granted' ? faRepeat : faXmarkCircle}
									label={user.status === 'Granted' ? 'switchInto' : 'expired'}
									onClick={() => closePopper() || switchSupportClient(user)}
									variant="blue"
									css={
										user.status === 'Granted'
											? undefined
											: css`
													border: 1px solid var(--red-10) !important;
													background-color: var(--red-10) !important;
													color: var(--red) !important;
												`
									}
								/>
							) : (
								<Button
									icon={faRightFromBracket}
									label="logout"
									onClick={() => closePopper() || switchSupportClient()}
									className="redButton"
									variant="blue"
									css={css`
										border: 1px solid var(--red) !important;
										background-color: var(--red) !important;
										color: var(--white) !important;
									`}
								/>
							)}
						</S.ProfileInnerRow>
						{user.clientUserId === currentUserId && supportAccessUntil && (
							<S.TimeLeft>
								<Typography color="var(--green)">
									{Math.round((supportAccessUntil - Date.now()) / 60000)} {t('minutes')}
								</Typography>
								<Icon icon={faArrowsRotate} />
							</S.TimeLeft>
						)}
					</S.ProfileOuterRow>
				))}
			</S.PaddingDiv>
		</S.SwitchPopperContainer>
	);
};

export default SwitchCustomer;
